import React, { useEffect, useState } from 'react';
import Switch from './Switch';
const KnowledgeBase = ({ viewType, root }) => {
    const [visible, setVisible] = useState(!root.closest('zds-navigation'));
    useEffect(() => {
        const navigation = root.closest('zds-navigation');
        if (!navigation)
            return;
        const open = (e) => {
            if (e.detail.identifier !== 'search-body')
                return;
            setVisible(true);
        };
        navigation.addEventListener('zdsNavigationBodyOpen', open);
        return () => {
            navigation.removeEventListener('zdsNavigationBodyOpen', open);
        };
    }, [root]);
    if (!visible) {
        return null;
    }
    return React.createElement(Switch, { viewType: viewType });
};
export default KnowledgeBase;
